// src/services/weatherService.ts
import { apiClient } from './apiConfig'

const pythonISO = (time: Date) => time.toISOString().replace(/Z$/, '+00:00');

export const getTotalCost = async (
  start_time: Date,
  stop_time: Date
): Promise<{'total_cost': number}> => {
  console.log('getTotalCost', start_time, stop_time);

  const response = await apiClient.get<any>('/get-total-cost', {
    params: {
      start_time: pythonISO(start_time),
      stop_time: pythonISO(stop_time)
    }
  });

  console.log('response.data', response.data);
  return response.data
}
